module.exports = __webpack_public_path__ + "img/B558.ee0b8233.jpg";